module.exports = __webpack_public_path__ + "src/img/rightward.57e99a49.svg";